import { useEffect, RefObject } from 'react';

type UseScrollProps = {
  containerRef?: RefObject<HTMLDivElement | null>;
  onLoadMore?: () => void;
  isInverted?: boolean;
};

export const useScroll = ({
  onLoadMore,
  containerRef,
  isInverted = false,
}: UseScrollProps) => {
  useEffect(() => {
    const container = containerRef?.current;
    if (!container) {
      return;
    }

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = container;

      if (isInverted) {
        if (scrollTop <= clientHeight * 0.5) {
          onLoadMore?.();
        }
      } else {
        if (scrollHeight - scrollTop <= clientHeight * 1.5) {
          onLoadMore?.();
        }
      }
    };

    container.addEventListener('scroll', handleScroll);
    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, [containerRef, onLoadMore, isInverted]);

  return null;
};
